import _regeneratorRuntime from 'babel-runtime/regenerator';

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(inicializarPizarra),
    _marked2 =
/*#__PURE__*/
_regeneratorRuntime.mark(fetchData),
    _marked3 =
/*#__PURE__*/
_regeneratorRuntime.mark(watchLoadConfig);

import { all, call, put, takeLatest, select } from 'redux-saga/effects';
import { inicializar, loadError, LOAD_CONFIG, cargarBarraHerramientas } from '../../actions';
import * as pizarraActions from '../../pizarra/actions';
import { barraHerramientasSelectors } from '../../selectors';
import * as gestorSesionesActions from '../../gestor-sesiones/actions';
import * as Util from '../../util'; // import * as indexedStorage from '../../util/indexed-storage'

import comprobarCaducidad from './comprobar-caducidad';

function inicializarPizarra(botones) {
  var lapiz, marcador;
  return _regeneratorRuntime.wrap(function inicializarPizarra$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          lapiz = botones.find(function (boton) {
            return boton.id === "Lapiz";
          });

          if (!lapiz) {
            _context.next = 6;
            break;
          }

          _context.next = 4;
          return put(pizarraActions.seleccionarColorLapiz(lapiz.colores[0]));

        case 4:
          _context.next = 6;
          return put(pizarraActions.seleccionarGrosorLapiz(lapiz.grosores[0]));

        case 6:
          marcador = botones.find(function (boton) {
            return boton.id === "Marcador";
          });

          if (!marcador) {
            _context.next = 14;
            break;
          }

          _context.next = 10;
          return put(pizarraActions.seleccionarAlphaMarcador(marcador.alphas[0]));

        case 10:
          _context.next = 12;
          return put(pizarraActions.seleccionarColorMarcador(marcador.colores[0]));

        case 12:
          _context.next = 14;
          return put(pizarraActions.seleccionarGrosorMarcador(marcador.grosores[0]));

        case 14:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function fetchData(action) {
  var _ref, paginas, config, sesiones, idUltimaSesionActiva, botones;

  return _regeneratorRuntime.wrap(function fetchData$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return all({
            paginas: Util.loadJson(action.ficheroPaginas),
            config: Util.loadJson(action.ficheroConfig)
          });

        case 3:
          _ref = _context2.sent;
          paginas = _ref.paginas;
          config = _ref.config; // titulo de la app

          document.title = config.configGeneral.titulo; // configurar indexed storage, importante hacer esto lo antes posible

          Util.setKeyStorageRoot(config.configGeneral.key); // yield indexedStorage.open(config.configGeneral.key)

          Util.setTitleRoot(config.configGeneral.titulo); // accion inicializar generica

          _context2.next = 11;
          return put(inicializar(config, paginas));

        case 11:
          _context2.next = 13;
          return Util.getStorageData('sesiones');

        case 13:
          sesiones = _context2.sent;
          _context2.next = 16;
          return Util.getStorageData('idUltimaSesionActiva');

        case 16:
          idUltimaSesionActiva = _context2.sent;
          _context2.next = 19;
          return put(gestorSesionesActions.inicializarSesiones(sesiones, idUltimaSesionActiva));

        case 19:
          _context2.next = 21;
          return put(cargarBarraHerramientas(config.configHerramientas));

        case 21:
          _context2.next = 23;
          return select(barraHerramientasSelectors.getBotones);

        case 23:
          botones = _context2.sent;
          _context2.next = 26;
          return call(inicializarPizarra, botones);

        case 26:
          _context2.next = 28;
          return put(action.action);

        case 28:
          _context2.next = 30;
          return call(comprobarCaducidad, config.configGeneral);

        case 30:
          _context2.next = 37;
          break;

        case 32:
          _context2.prev = 32;
          _context2.t0 = _context2['catch'](0);
          window.console.error(_context2.t0);
          _context2.next = 37;
          return put(loadError(_context2.t0));

        case 37:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[0, 32]]);
}

function watchLoadConfig() {
  return _regeneratorRuntime.wrap(function watchLoadConfig$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return takeLatest(LOAD_CONFIG, fetchData);

        case 2:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

export default watchLoadConfig;